/* eslint no-unused-vars: 1 */

export default class AbstractStoreService {
    static serviceName = 'StoreService';

    setStore(store) {}

    dispatch(...args) {}

    // eslint-disable-next-line getter-return
    get state() {}

    observeStore(select, onChange, isEqualFunction) {}
}
